import type { FilterKeys } from '@/pages/opinion/components/FilterCommon/types';
import {
  barHIcon,
  barIcon,
  barSIcon,
  commonBarHIcon,
  coordinateIcon,
  lineIcon,
  pieIcon,
} from '@/pages/opinion/constants/chart';

export const sortByOptions = [
  { text: 'Hot', value: 'important_score' },
  { text: 'Time', value: 'comment_time' },
];

// 后续判断游戏
export const gameStoreSelectPubg = [
  { text: 'Most Valuable', value: 'order_number' },
  { text: 'Validation', value: 'sort_isvalid' },
  { text: 'Time', value: 'comment_time' },
];

export const gameStorePCOptions = [
  { text: 'Time', value: 'comment_time' },
  { text: 'Validation', value: 'sort_isvalid' },
  { text: 'Playtime on Record', value: 'record_duration' },
];

export const gameStoreSelectOptions = [
  { text: 'Time', value: 'comment_time' },
  { text: 'Validation', value: 'sort_isvalid' },
];

export const mentionsIcons = [barIcon, lineIcon];

export const mentionsVersionIcons = [coordinateIcon, pieIcon];
export const mentionsTopicIcons = [commonBarHIcon, pieIcon];

export const mentionsIconsMap: any = {
  topic: mentionsTopicIcons,
  version: mentionsVersionIcons,
};

export const sentimentIcons = [barHIcon, barSIcon];

const defaultFilter: Array<FilterKeys> = [
  'date',
  'regionAndLanguage',
  'channel',
  'sentiment',
  'rating',
  'monitor',
  'topic',
  'invalid',
];

export const topicFilterOptionsMap = {
  pc: [...defaultFilter, 'monitorSource'],
  console: [...defaultFilter, 'monitorSource', 'platform'],
  mobile: [...defaultFilter, 'version'],
};

export const othersList = ['others', 'other', 'Others', 'Other'];
